import * as React from 'react';

import { FormField } from 'components/form';

import { __t, applyTranslations } from 'utils/language';
import { FASHION_STYLES } from 'utils/influencers';

import './profile-fashion-styles.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./profile-fashion-styles.i18n.json'));

import type {
  InfluencerFashionIdentityType,
  InfluencerInputToggleItem
} from 'types';

interface Props {
  renderInputToggles: (
    type: InfluencerFashionIdentityType,
    items: Array<InfluencerInputToggleItem>,
    limit?: number
  ) => React.ReactNode
}

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'profile_fashion_styles';

const ProfileFashionStyles: React.FC<Props> = ({
  renderInputToggles
}) => {
  const renderItems = (): React.ReactNode => {
    const items = FASHION_STYLES.map(value => ({
      value,
      label: __t(`${COMMON_MSG_KEY}.fashion_styles.${value}`)
    }));

    return (
      <div className="profile-fashion-styles__toggles">
        {renderInputToggles('fashionStyles', items)}
      </div>
    );
  };

  return (
    <div className="profile-fashion-styles">
      <FormField
        label={__t(`${MSG_KEY}.heading`)}
        labelType="highlighted"
        direction="column"
        showValidationIcon={false}
        className="profile-fashion-styles__section"
      >
        <div className="profile-fashion-styles__section-subtitle">
          {__t(`${MSG_KEY}.description`)}
        </div>
        {renderItems()}
      </FormField>
    </div>
  );
};

export default ProfileFashionStyles;
